import type { ButtonHTMLAttributes } from "react";
import type { LucideIcon } from "lucide-react";

import { mergeClassNames } from "./classNames";
import { Tooltip } from "./Tooltip";
import "./controls.css";

export interface IconButtonProps
  extends Omit<
    ButtonHTMLAttributes<HTMLButtonElement>,
    "aria-label" | "children"
  > {
  icon: LucideIcon;
  label: string;
  tooltip?: string;
  variant?: "neutral" | "accent";
}

export function IconButton({
  icon: Icon,
  label,
  tooltip,
  variant = "neutral",
  className,
  type = "button",
  ...buttonProps
}: IconButtonProps) {
  const button = (
    <button
      {...buttonProps}
      aria-label={label}
      className={mergeClassNames(
        "ui-icon-button",
        "ui-icon-button--" + variant,
        className
      )}
      type={type}
    >
      <Icon aria-hidden="true" className="ui-icon-button__icon" />
    </button>
  );

  if (!tooltip) {
    return button;
  }

  return <Tooltip content={tooltip}>{button}</Tooltip>;
}
